import { SectionForm } from "../sections/blocks/SectionForm";
import { WrapperComponents } from "../wrappers/WrapperComponents";
import { SectionBlockMediaFeatured } from "../sections/blocks/SectionBlockMediaFeatured";
import { HeroPrimary } from "../headers/HeroPrimary";
import { SectionBlockMediaCalloutCard } from "../sections/blocks/SectionBlockMediaCalloutCard";
import { SectionBlockAccordionContent } from "../sections/blocks/SectionBlockAccordionContent";

export interface ITemplateContact {
  data: any;
}

export default function TemplateContact({ data }: ITemplateContact) {
  const {
    heroPrimary,
    blockMediaCalloutCard,
    sectionForm,
    form,
    featuredImage,
    sectionBlockAccordionContent,
  } = data;

  return (
    <>
      {heroPrimary && <HeroPrimary data={heroPrimary} />}
      <WrapperComponents>
        {blockMediaCalloutCard && (
          <SectionBlockMediaCalloutCard
            data={blockMediaCalloutCard}
            theme="colour"
          />
        )}
        {sectionForm && form && <SectionForm data={sectionForm} form={form} />}

        {featuredImage && (
          <SectionBlockMediaFeatured
            data={{
              image: featuredImage,
            }}
          />
        )}

        {sectionBlockAccordionContent && (
          <SectionBlockAccordionContent data={sectionBlockAccordionContent} />
        )}
      </WrapperComponents>
    </>
  );
}
